import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule, MatIconModule, MatDialog, MatCheckboxModule, MatPaginatorModule, MatPaginatorIntl } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LicitacoesComponent } from './components/licitacoes/licitacoes.component';
import { LicitacaoListSimpleComponent } from './components/licitacao-list-simple/licitacao-list-simple.component';
import { LicitacaoGetOneComponent} from './components/licitacao-get-one/licitacao-get-one.component';
import { LicitacaoEditComponent } from './components/licitacao-edit/licitacao-edit.component';
import { LoadingComponent } from './components/loading/loading.component';

import { LoginService } from './services/login.service';
import { LicitacaoService } from './services/licitacao.service';
import { Base64Service } from './services/base64.service';
import { LoadingService } from './services/loading.service';
import { LoadingFileService } from './services/loading-file.service';
import { UserSessionService } from './services/user-session.service';

import { Ng2OrderModule } from 'ng2-order-pipe';
import { LoadingFileComponent } from './components/loading-file/loading-file.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { ComponentsComponent } from './components/components.component';
import { TextMaskModule } from 'angular2-text-mask';
import { DomService } from './services/dom-service.service';
import { CpfCnpjMaskDirective } from './util/cpf_cnpj-mask';
import { PaginacaoComponent } from './components/paginacao/paginacao.component';
import { CustomMatPaginatorIntl } from './components/paginacao/customMatPaginatorIntl';
import { ListagemContratoComponent } from './components/contrato/listagem-contrato/listagem-contrato.component';
import { ContratoInfoComponent } from './components/contrato/contrato-info/contrato-info.component';
import { ContratoService } from './components/contrato/contratoService';
import { ExportarBtnComponent } from './components/exportar/exportar-btn.component';
import { ItemExportacaoComponent } from './components/exportar/itemExportacao/item-exportacao.component';
import {ContratoByNumerocontratoComponent} from './components/contrato/contrato-by-numerocontrato/contrato-by-numerocontrato.component';
import {NumeroLicitacaoMaskDirective} from './util/numero_licitacao-mask';
import { HeaderComponent } from './components/header/header.component';
import {LastActivityService} from './services/last-activity.service';

@NgModule({
  declarations: [
    AppComponent,
    PaginacaoComponent,
    LoginComponent,
    DashboardComponent,
    SidebarComponent,
    NavbarComponent,
    LicitacoesComponent,
    LicitacaoListSimpleComponent,
    LicitacaoGetOneComponent,
    LicitacaoEditComponent,
    LoadingComponent,
    LoadingFileComponent,
    DialogComponent,
    ComponentsComponent,
    ContratoInfoComponent,
    CpfCnpjMaskDirective,
    ExportarBtnComponent,
    ItemExportacaoComponent,
    ListagemContratoComponent,
    ContratoByNumerocontratoComponent,
    NumeroLicitacaoMaskDirective,
    HeaderComponent
  ],
  imports: [
    TextMaskModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatExpansionModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatCheckboxModule,
    Ng2OrderModule
  ],
  providers: [
    LoginService,
    ContratoService,
    LicitacaoService,
    Base64Service,
    LoadingService,
    UserSessionService,
    LoadingFileService,
    DomService,
    LastActivityService,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],

  bootstrap: [AppComponent],

  entryComponents: [
    DialogComponent,
    ContratoInfoComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts